import React, { useState } from 'react';
import { Button, Col, Form, Input, notification, Row } from 'antd';
import AdminLogo from '../admin/components/login/assets/images/admin_logo.png';
import '../admin/components/login/assets/css/login.css';
import axios from 'axios';
import { configure } from 'axios-hooks';

import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiSlice } from '../../store/apiSlice';

const instance = axios.create({
  withCredentials: true,
  crossDomain: true,
  baseURL: `${process.env.REACT_APP_AXIOS_URL}ops/auth`,
  'Access-Control-Allow-Origin': '*',
  sameSite: null,
  secure: false,
});
const admin_url = '/sb/admin';

configure({ instance });

export default function AdminLogin(props) {
  const [, setUsername] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);

  const dispatch = useDispatch();

  const onFinishLogin = (values) => {
    const formData = new FormData();
    formData.append('username', values.username.trim());
    formData.append('password', values.password);

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    instance
      .post('login', formData, config)
      .then((res) => {
        setUsername('');
        props.history.push(`${admin_url}/dashboard`);
        dispatch(apiSlice.util.invalidateTags(['FisheryUser', 'User', 'Subscription', 'PrintSettings']));
      })
      .catch(() => {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Incorrect Details. Please try again.',
        });
      })
      .finally(() => {});
  };

  const onFinishForgotPassword = (values) => {
    let payload_data = { email: values.username };
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    instance
      .post('user/reset', payload_data, config)
      .then((res) => {
        notification.success({
          message: <div className='gSemiBold'>Success!</div>,
          style: { border: '1px #2CB972 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: res.data.result,
        });
      })
      .catch(() => {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Incorrect Details. Please try again.',
        });
      })
      .finally(() => {});
  };

  const onFinishFailed = () => {};

  const refreshToken = () => {
    instance
      .get('refresh')
      .then((res) => {})
      .catch((err) => console.log(err))
      .finally(() => {});
  };

  // const handleLogout = () => {
  //   try {
  //     instance
  //       .get('logout')
  //       .then((res) => console.log(res))
  //       .catch((err) => console.log(err))
  //       .finally(() => {
  //         setUsername(null);
  //         setEmail(null);
  //       });
  //   } catch (err) {
  //     return [];
  //   }
  // };

  // useEffect(() => {
  //   refreshToken();
  // }, []);

  return (
    <div className='admin-login-page sb-dark-blue-bg'>
      <Helmet>
        <title>Login to Swimbooker Admin | swimbooker</title>
      </Helmet>
      <div id='admin-login-form-content'>
        <div className='login-inside-form-content'>
          <Row>
            <Col span={24} className='txt-center mg-bottom-20'>
              <img
                className='mg-right-10'
                width='30'
                alt='admin_logo'
                src={AdminLogo}
              />
              <span className='admin-logo-text gSemiBold'>
                <span className='fs-30'>Swimbooker Admin</span>
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className='admin-login-form-wrapper'>
                <div className='admin-login-form-items'>
                  <Form
                    name='basic'
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={
                      forgotPassword ? onFinishForgotPassword : onFinishLogin
                    }
                    onFinishFailed={onFinishFailed}
                  >
                    <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                      Email:
                    </p>
                    <Form.Item
                      // label="Username"
                      name='username'
                      rules={[
                        {
                          required: true,
                          message: 'Please input your username!',
                        },
                      ]}
                    >
                      <Input className='br5 email' />
                    </Form.Item>

                    {forgotPassword ? (
                      <Form.Item>
                        <Button
                          className='admin-login-btn light-green-bg gBold'
                          type='primary'
                          htmlType='submit'
                        >
                          Send Login Link
                        </Button>
                      </Form.Item>
                    ) : (
                      <>
                        <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                          Password:
                        </p>
                        <Form.Item
                          // label="Password"
                          name='password'
                          rules={[
                            {
                              required: true,
                              message: 'Please input your password!',
                            },
                          ]}
                        >
                          <Input.Password className='br5 admin-secret' />
                        </Form.Item>

                        <Form.Item>
                          <Button
                            className='admin-login-btn light-green-bg gBold'
                            type='primary'
                            htmlType='submit'
                          >
                            SIGN IN
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={24} className='txt-center'>
              <div className='contact-us-info-admin-login-wrapper'>
                <p className='contact-us-info-admin-login-content mg-bottom-20'>
                  <span className='dark-swim-blue gLight'>
                    If you have issue logging in, please inform management.
                  </span>
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
